export interface CookieConsentOptions {
	necessary: boolean; // Always true, can't be toggled
	analytics: boolean;
	marketing: boolean;
}
export const COOKIE_NAME = "consent";
// Cookie options shared across all consent cookies
export const COOKIE_OPTIONS = {
	path: "/",
	secure: true,
	sameSite: "lax" as const,
	maxAge: 365 * 24 * 60 * 60, // 1 year
	// Add domain if needed based on environment
	domain:
		typeof process !== "undefined" &&
		process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
			? ".jace.ai"
			: undefined,
} as const;

type SetCookieFunction = (
	name: typeof COOKIE_NAME,
	value: any,
	options?: typeof COOKIE_OPTIONS,
) => void;

// Helper function to get cookie value as a dictionary
export function getConsentCookie(cookies: {
	consent?: string | CookieConsentOptions;
}): CookieConsentOptions | null {
	const consent = cookies.consent;
	if (!consent) return null;

	try {
		const { necessary, analytics, marketing } = consent as any;
		if (
			typeof necessary === "boolean" &&
			typeof analytics === "boolean" &&
			typeof marketing === "boolean"
		) {
			return { necessary, analytics, marketing };
		}
	} catch {
		return null;
	}
	return null;
}

// Helper function to update a specific consent preference
export function updateConsentCookie(
	currentCookies: { consent?: string },
	setCookie: SetCookieFunction,
	updates: Partial<CookieConsentOptions>,
): void {
	const current = getConsentCookie(currentCookies) || {
		necessary: true,
		analytics: false,
		marketing: false,
	};

	const newConsent = {
		...current,
		...updates,
		necessary: true, // Always true
	};

	setCookie(COOKIE_NAME, JSON.stringify(newConsent), COOKIE_OPTIONS);
}
